module.exports = __webpack_public_path__ + "img/11.8ed2da6d.svg";